<template>
<v-dialog v-model="visible" lazy :scrollable="scrollable" :persistent="persistent" :max-width="width" @keydown.esc="visible=false">
  <v-card v-if="visible">
    <v-btn icon flat color="grey" @click="visible=false" style="position:absolute;top:0px;right:0px;">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card-title>
      <slot name="title"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <slot></slot>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <slot name="actions">
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="visible=false">{{ $t('dialog.close') }}</v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 400
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Dialog.vue